export default __webpack_public_path__ + "static/media/V380_CoC.a114b814.pdf";